import React, {useEffect, useState} from 'react';
import _axios from '../../../httpService';
import Loader from "../../Loader";
import SingleReport from "./SingleReport";
import {useLocation} from "react-router-dom";
import Swal from "sweetalert2";

const ReportShow = () => {
  let id = undefined;
  const prefixUrl = localStorage.getItem("apiUrl") + "/userDashboardData/";
  const location = useLocation();
  const [dataState, setDataState] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    if (location.state) {
      id = location.state.sidebarItemId;
      if (id && id !== "-1" && id !== undefined) {
        _axios.get(prefixUrl + "?request=dashboardReports&dashboardId=" + id).then(r => {
          setDataState(r.data);
          setRefreshKey(prev => prev + 1);
        });
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: "لطفا مجددا تلاش کنید.",
        html: `<div class='small'>location.state مقدار  صحیح نیست</div>`,
        showDenyButton: false,
        showCancelButton: false,
        showConfirmButton: false,
      });
    }
  }, [location.state?.sidebarItemId]);

  const widthClass = (array) => {
    const length = array.length;
    return length === 4 ? "width25" : length === 3 ? "width33" : length === 2 ? "width50" : length === 1 ? "width100" : "width100";
  };

  try {
    return (
      <div key={refreshKey} className={"p-4"} style={{width: "100%", height: "88vh", overflow: "scroll"}}>
        {dataState.length > 0 ? (
          <div className={""} style={{width: "100%", height: "80vh"}}>
            {dataState.map((rows, rowIndex) => (
              <div
                key={rowIndex}
                className={""}
                style={{
                  width: "100%",
                  height: "auto",
                  display: 'flex',
                  flexFlow: "row wrap",
                  justifyContent: "space-around",
                }}
              >
                {rows.map((cols, colIndex) => (
                  <div
                    key={colIndex}
                    className={widthClass(rows) + " position-relative border rounded text-center "}
                    style={{
                      height: "80vh",
                      padding: 20,
                      maxHeight: '85vh',
                      overflow: 'scroll',
                      border: '1px solid whitesmoke',
                    }}
                  >
                    <SingleReport
                      title={cols.title}
                      id={cols.id}
                      type={cols.type}
                      hasDate={cols.hasDate}
                      chartType={cols.chartType}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        ) : (
          <Loader/>
        )}
      </div>
    );
  } catch (e) {
    return <>{e.toString()}</>;
  }
};

export default ReportShow;
